import React, { useCallback } from 'react';
import { ConfirmationModal } from 'seagull';
import { useGlobalContext } from 'seagull';
import { CopyToClipboard } from "../../components/CopyToClipboard/CopyToClipboard";
import { useFeatureFlags } from "../useFeatureFlags";
import { CopyLinkForProposalModal } from "./CopyLinkForProposalModal";
export function useOpenCopyLinkModal() {
  const globalContext = useGlobalContext();
  const {
    MULTIPLE_RECEPIENTS
  } = useFeatureFlags();
  const openCopyLinkForAgreement = useCallback(function openCopyLinkModal(props) {
    const {
      testid,
      url
    } = props;
    return globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          title: "Copy link",
          content: /*#__PURE__*/React.createElement(CopyToClipboard, {
            "data-testid": testid,
            value: url
          }),
          primaryButtonLabel: "Close",
          onPrimaryButtonClick: dismissModal,
          onCloseButtonClick: dismissModal
        });
      }
    });
  }, []);
  const openCopyLinkForProposal = props => {
    const {
      testid,
      url,
      recipients
    } = props;
    if (MULTIPLE_RECEPIENTS && recipients) {
      return globalContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;
          return /*#__PURE__*/React.createElement(ConfirmationModal, {
            width: '900px',
            title: "Copy link",
            content: /*#__PURE__*/React.createElement(CopyLinkForProposalModal, {
              "data-testid": testid,
              recipients: recipients
            }),
            primaryButtonLabel: "Close",
            onPrimaryButtonClick: dismissModal,
            onCloseButtonClick: dismissModal
          });
        }
      });
    } else if (url) {
      return openCopyLinkForAgreement({
        testid,
        url
      });
    }
  };
  return {
    openCopyLinkForAgreement,
    openCopyLinkForProposal
  };
}